export default function useSanitiseReg(reg: string) {
  if(!reg){
    return "";
  }
  const l = reg.length;
  if (l <= 4) {
    return reg
  }
  return reg.substring(0, 4) + " " + reg.substring(4);
}
